export default __webpack_public_path__ + "static/img-tarjeta-ed18056e2a398861f29fea24c55769da.png";